import { call, select } from "typed-redux-saga";

import { Identifier, TreeEngineState } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/core/store";
import { TreeEngineSelectors } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client";
import { TreeEngineDataHolder } from "@com.mgmtp.a12.treeengine/treeengine-core/lib/extensions/client/internal/data-holder";
import { LocalizableArgs } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { localizableFromLocaleResources } from "../../localization";
import { toDateToPrettyString } from "../../utilities/dateTimeUtils";
import { putErrorNotification } from "../../utilities/notificationUtils";
import { TEXTBAUSTEINE_VERFAHREN_DOCUMENT } from "../../utilities/variables/documentModelName";

import { isDocumentWithCorrelatedFachverfahrenKey } from "./textbausteineTypeGuard";

export function* getFvKeyFromTextbausteinVerfahrenNode(nodeIdentifier: Identifier, activityId: string) {
	if (nodeIdentifier.type !== TEXTBAUSTEINE_VERFAHREN_DOCUMENT) {
		return;
	}

	const nodesDataHolders = yield* select(TreeEngineSelectors.nodesDataHolders(activityId));
	if (!nodesDataHolders) {
		return;
	}

	const rootNodeDataHolder = nodesDataHolders.find(nodeDataHolder =>
		TreeEngineDataHolder.Descriptor.RootNodes.isAssignableFrom(nodeDataHolder.descriptor)
	);
	if (!rootNodeDataHolder) {
		return;
	}
	const rootNode = rootNodeDataHolder.data?.[nodeIdentifier.type]?.[nodeIdentifier.id];

	if (
		!rootNode ||
		!TreeEngineState.Node.isAssignableFrom(rootNode) ||
		!isDocumentWithCorrelatedFachverfahrenKey(rootNode.document)
	) {
		return;
	}

	return rootNode.document.root.correlatedFachverfahrenKey;
}

export function* handleTextbausteinTransferError(fvKey: string, localizationKey: string, error: unknown) {
	const localizableArgs: LocalizableArgs = {
		appKey: { type: "plain", value: fvKey },
		timestamp: { type: "plain", value: toDateToPrettyString(new Date()) }
	};
	yield* call(
		putErrorNotification,
		localizableFromLocaleResources(localizationKey, localizableArgs),
		error,
		undefined,
		`getFvKeyFromTextbausteinVerfahrenNode:${fvKey}`
	);
}
